import { render, staticRenderFns } from "./Switch.htm?vue&type=template&id=70bf3db1&scoped=true&"
import script from "./Switch.js?vue&type=script&lang=js&"
export * from "./Switch.js?vue&type=script&lang=js&"
import style0 from "./Switch.scss?vue&type=style&index=0&id=70bf3db1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf3db1",
  null
  
)

export default component.exports